import React from 'react'
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux'
import { UserMenu } from './UserMenu';
import logo from '../assets/logoYnombre.png'
import logoClaro from '../assets/logoYnombreClaro.png'
import { Spin } from '../admin/panelComponents/productsPanel/Spin';


export const Navbar = () => {


    const {name ,acces , checking} = useSelector(state => state.auth)

    


  return (
        <nav className='container-fluid  navBar'>

            <div className='nav-container container'>

                    <div className='col-10 col-sm-4 col-lg-2 logo-container '>
                    
                        <Link to="/"> <img className='logo logo-oscuro' src={logo} alt="" /> <img className='logo logo-claro' src={logoClaro} alt="" /> </Link>

                    </div>
                    {checking && 
                        <div className='spiner '>
                            <Spin/>
                        </div>
                    }
                    {!checking &&
                    
                        <div className='col-2 col-lg-10 nav-menu'>

                            <div className='col-8'>
                                {/* PAGINACION */}
                            </div>

                            <div className='col-4 ui-nav'>

                                <div className='adminPanel-nav'>

                                    { (acces === "admin")&&
                                    
                                    <Link to="/admin" className='nav-menu-items'>AdminPanel</Link>
                                    
                                    }
                                </div>
                                <div className='user-nav'> 

                                    {(name)?
                                        
                                        <UserMenu />
                                    :
                                        <Link to="/login" className='nav-menu-items'> Iniciar Session </Link>

                                    }
                                </div>

                            </div>

                        </div>
                    }
            </div>

        </nav>


  )
}
